import { Grid } from "@material-ui/core";
import { useContext, useEffect, useMemo } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { merge, Observable, Subject } from "rxjs";
import { filter, skip, take } from "rxjs/operators";
import { ErrorText } from "../../../../../../../components/billing";
import { GridItem } from "../../../../../../../components/layout";
import { InnerFaceAttachment } from "../../../../../../../store/launch-configurations/models/default-fields/face-attachment";
import { FileAttachmentContext } from "./file-attachment-context";
import { Container } from "../../components";
import { AttachmentFormType } from "../common/attachment";
import { useFileUploader } from "./file-upload-hook";

export interface IProofofFaceProps {
  emailChange: Observable<string>;
  setFilesUploaded: (b: boolean) => void;
}

export function ProofofFace({
  emailChange,
  setFilesUploaded,
}: IProofofFaceProps) {
  const { t } = useTranslation("fields");
  const { files, setFile, emailAddress } = useContext(FileAttachmentContext);
  debugger;
  const {
    formState: { isSubmitted },
  } = useFormContext();

  const form = useForm<AttachmentFormType>({
    defaultValues: useMemo(
      () => ({
        type: "FACE",
        file: files.FACE?.file,
      }),
      []
    ),
  });

  // const valueChange = useMemo(() => new Subject<AttachmentFormType>(), []);

  const [faceSubject, faceUploaded, faceUploadSuccess] = useFileUploader(
    "FACE",
    emailChange
  );

  useEffect(() => {
    const sub = faceUploadSuccess.subscribe((d) => {
      setFile("FACE", d);
    });
    return () => sub.unsubscribe();
  }, [faceUploadSuccess, setFile]);

  const error = useMemo(
    () =>
      !faceUploaded && isSubmitted && !files.FACE
        ? new Error("Field is required")
        : undefined,
    [faceUploaded, isSubmitted, files.FACE]
  );

  // Skip the first entry to avoid reuploading if there's a default value
  // useEffect(() => {
  //   debugger;
  //   merge(
  //     valueChange.pipe(
  //       tap(s => console.log('SKIP1:' + JSON.stringify(s))),
  //       skip(1)
  //     ),
  //    valueChange.pipe(
  //     tap(s => console.log('TAKE1:' + JSON.stringify(s))),
  //     take(1),
  //     filter(
  //       () =>
  //         files.FACE !== undefined &&
  //         files.FACE.emailAddress !== undefined &&
  //         files.FACE?.emailAddress !== emailAddress
  //     )
  //     )
  //   ).subscribe(faceSubject);
  // }, [faceSubject, valueChange, emailAddress, files.FACE]);

  useEffect(() => {
    const sub = form.watch((values) => {
      debugger;
      faceSubject.next(values);
    });
    return () => sub.unsubscribe();
  }, [faceSubject, form.watch, form]);

  useEffect(() => {
    if (faceUploaded || files.FACE) {
      setFilesUploaded(true);
    } else {
      setFilesUploaded(false);
    }
  }, [setFilesUploaded, faceUploaded, files.FACE]);

  return (
    <Container>
      <Grid container spacing={3}>
        <GridItem top xs={12}>
          <strong>{t("selfie")}</strong>
        </GridItem>
        <Grid item xs={12}>
          <FormProvider {...form}>
            <InnerFaceAttachment
              path="file"
            />
          </FormProvider>
        </Grid>
        {error ? (
          <Grid xs={12}>
            <ErrorText>{error?.message}</ErrorText>
          </Grid>
        ) : null}
      </Grid>
    </Container>
  );
}
